<template>
  <div class="my-8 flex gap-2"
        :class="{ 'justify-between': prev_subject && next_subject,
                  'justify-end': !prev_subject,
                  'justify-start': !next_subject }">

    <div v-if="prev_subject" @click="$emit( 'handle_click', prev_subject.id )"
         class="cursor-pointer mr-1 w-1/2 sm:w-1/5 p-4 bg-ams-blue text-white content-end  hover:bg-ams-blue-dark">
      <div>
        <span class="inline-block align-middle mr-2 text-white fill-current">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
        </span>
        <span v-html="prev_subject.title"></span>
      </div>
    </div>

    <div v-if="next_subject" @click="$emit( 'handle_click', next_subject.id )"
         class="cursor-pointer ml-1 w-1/2 sm:w-1/5 p-4 bg-ams-blue text-white content-end text-right hover:bg-ams-blue-dark">
      <div>
        <span v-html="next_subject.title"></span>
        <span class="inline-block align-middle ml-2 text-white fill-current">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'prev_subject', 'next_subject' ]
}
</script>